function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
// @ts-nocheck
/* eslint-disable import/no-extraneous-dependencies */ import classnames from 'classnames';
import * as React from 'react';
import { filterDataProps } from '../../utils/FilterDataProps';
import { st, classes } from './CoreInput.st.css';
var _React_Component;
export class CoreInput extends (_React_Component = React.Component) {
    render() {
        const { focus } = this.state;
        const { error, disabled, prefix, suffix, style: inlineStyle, id } = this.props;
        const { error: errorProp, style: styleProp, prefix: prefixProps, suffix: suffixProp, inputClassName, className, inputRef, ...allOtherProps } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            className: st(classes.root, {
                disabled,
                error: !!error && !disabled,
                focus
            }, className),
            style: inlineStyle,
            ...filterDataProps(this.props)
        }, prefix, /*#__PURE__*/ React.createElement("input", {
            id: id,
            ...allOtherProps,
            ref: this._extractRef,
            className: classnames(classes.nativeInput, inputClassName),
            onBlur: this.handleBlur,
            onFocus: this.handleFocus
        }), suffix);
    }
    focus() {
        this.input.focus();
    }
    blur() {
        this.input.blur();
    }
    select() {
        this.input.select();
    }
    getSelectionStart() {
        return this.input.selectionStart;
    }
    getSelectionEnd() {
        return this.input.selectionEnd;
    }
    setSelectionRange(start, end) {
        this.input.setSelectionRange(start, end);
    }
    constructor(...args){
        super(...args), _define_property(this, "state", {
            focus: false
        }), _define_property(this, "input", void 0), _define_property(this, "_extractRef", (ref)=>{
            const { inputRef } = this.props;
            this.input = ref;
            if (inputRef) {
                inputRef(ref);
            }
        }), _define_property(this, "handleFocus", (event)=>{
            this.setState({
                focus: true
            });
            this.props.onFocus(event);
        }), _define_property(this, "handleBlur", (event)=>{
            this.setState({
                focus: false
            });
            this.props.onBlur(event);
        });
    }
}
_define_property(CoreInput, "displayName", 'CoreInput');
_define_property(CoreInput, "defaultProps", {
    type: 'text',
    onFocus: ()=>null,
    onBlur: ()=>null,
    onChange: ()=>null
});

//# sourceMappingURL=CoreInput.js.map